// extracted by mini-css-extract-plugin
export default {"ticketListDefault":"TicketList_ticketListDefault__b3qQX","ticketInformation":"TicketList_ticketInformation__YGBD6","ticketListWithSpace":"TicketList_ticketListWithSpace__GNb30"};